import useTranslation from 'canvas_states/translation/useTranslation';
import FullWidthBannerWithAction from '../../../atoms/FullWidthBannerWithAction';
import useRedirectToCallback from '../../../utils/callbackUrl/useRedirectToCallback';
import useWebCheckInCallback from '../utils/useWebCheckInCallback';
import useAppRouter from '../../../hooks/useAppRouter';
import useCommmonEvents from '../../../../libs/utils/analytics/useCommonEvents';
import { GoogleAnalyticClick } from '../../../../../types/analytics/GoogleAnalyticsEvent';

interface WebCheckInFullWidthBannerProps {
  dataTestId?: string;
}
const WebCheckInFullWidthBanner: React.FC<WebCheckInFullWidthBannerProps> = ({ dataTestId }) => {
  const { callbackUrl } = useWebCheckInCallback().states;
  const { redirectToCallback } = useRedirectToCallback().actions;
  const { isConfirmationRoute } = useAppRouter().states;
  const { t } = useTranslation().actions;
  const { publishClick } = useCommmonEvents().actions;
  // any further logic that is done to text would require a custom hook as a util
  const text = isConfirmationRoute ? t('offer.web-check-in.continue') : t('offer.web-check-in.continue-long');

  const onClick = async function () {
    publishClick(GoogleAnalyticClick.MANAGE_MY_BOOKING_NO_THANKS, dataTestId ?? 'banner');
    await redirectToCallback(callbackUrl);
  };

  return <FullWidthBannerWithAction onClick={async () => await onClick()} dataTestId={dataTestId} text={text} />;
};
export default WebCheckInFullWidthBanner;
